module.exports = __webpack_public_path__ + "img/undraw_My_universe_re_txot.85fc145b.svg";